// @docs https://[domain]/api/v1/docs
export default {
  List: "/departments",
  Detail: "/departments",
  Update: "/departments",
  Create: "/departments",
  Delete: "/departments",
  ListShort: "/departments/short",
};
